<template>
  <div>
    <b-card>
      <b-tabs content-class="mt-3" pills>
        <b-tab title="Мої дані" :active="!$route.params.tab">
          <b-overlay
            :show="isLoading"
            variant="white"
            rounded="sm"
            spinner-variant="warning"
          >
            <div class="form-group">
              <label>Ім'я</label>
              <input
                type="text"
                class="d-block w-100"
                v-model="user.first_name"
              />
            </div>
            <div class="form-group">
              <label>Прізвище</label>
              <input
                type="text"
                class="d-block w-100"
                v-model="user.last_name"
              />
            </div>
            <div class="form-group" v-if="user.phone_number">
              <label>Номер телефону</label>
              <input
                type="text"
                class="d-block w-100"
                v-model="user.phone_number"
                disabled
              />
            </div>

            <div class="form-group">
              <b-button @click="saveChanges" variant="primary"
                >Зберегти зміни</b-button
              >
            </div>
          </b-overlay>
        </b-tab>
        <b-tab
          title="Верифікація"
          :active="$route.params.tab == 'verification'"
        >
          <myProfileVerification />
        </b-tab>
      </b-tabs>
    </b-card>
  </div>
</template>

<script>
import myProfileVerification from "@/views/my/my-profile-verification.vue";
import { mapGetters } from "vuex";
export default {
  components: {
    myProfileVerification,
  },
  data() {
    return {
      isLoading: false,
      user: {
        first_name: "",
        last_name: "",
      },
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  methods: {
    async getUserData() {
      this.isLoading = true;
      var res = await this.$api.get("/frontend/users/me");
      if (res.data.success) {
        this.user = res.data.data;
      }
      this.isLoading = false;
    },
    async saveChanges() {
      this.isLoading = true;
      await this.$api.post("/frontend/users/update", {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
      });

      this.$store.commit("setUserData", this.user);
      this.$toast.success("Зміни збережено");

      this.isLoading = false;
    },
  },
  mounted() {
    this.getUserData();
  },
};
</script>

<style lang="scss" scoped></style>
